module.exports = require("./ca-ES-VALENCIA");